/* eslint-disable no-magic-numbers */

export enum FormulaErrorCode {
  NO_ERROR = 0,
  ERROR_CIRCULAR_REFERENCE = 1,
  ERROR_INVALID_REFERENCE = 2,
  ERROR_INVALID_SYNTAX = 3,
  ERROR_INVALID_DATE = 4,
  ERROR_INVALID_DATE_RANGE = 5,
  ERROR_INVALID_OUTPUT_FREQUENCY = 6,
  UNSPECIFIED_ERROR = 7
}

export enum FormulaErrorCodeString {
  NO_ERROR = 'NO_ERROR',
  ERROR_CIRCULAR_REFERENCE = 'ERROR_CIRCULAR_REFERENCE',
  ERROR_INVALID_REFERENCE = 'ERROR_INVALID_REFERENCE',
  ERROR_INVALID_SYNTAX = 'ERROR_INVALID_SYNTAX',
  ERROR_INVALID_DATE = 'ERROR_INVALID_DATE',
  ERROR_INVALID_DATE_RANGE = 'ERROR_INVALID_DATE_RANGE',
  ERROR_INVALID_OUTPUT_FREQUENCY = 'ERROR_INVALID_OUTPUT_FREQUENCY',
  UNSPECIFIED_ERROR = 'UNSPECIFIED_ERROR'
}

export interface FormulaError {
  error_code: FormulaErrorCode;
  is_valid: boolean;
}
